import { render } from "./ArticlePreview.vue?vue&type=template&id=e48994a2&scoped=true"
import script from "./ArticlePreview.vue?vue&type=script&lang=js"
export * from "./ArticlePreview.vue?vue&type=script&lang=js"

import "./ArticlePreview.vue?vue&type=style&index=0&id=e48994a2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e48994a2"

export default script